import { Link, useLocation } from 'react-router-dom';

const NavBar = () => {
    const location = useLocation();

    // Hide navbar for individual blog posts
    if (location.pathname.match(/^\/blog\/[^/]+$/)) {
        return null;
    }

    return (
        <header className="top-bar">
            <Link to="/" className="brand">Omarmdv®</Link>
            <div className="nav-group">
                <span className="nav-label">Quick Links</span>
                <nav className="nav-links">
                    <Link to="/" className={location.pathname === "/" ? "active" : ""}>Home</Link>
                    {location.pathname === "/" ? (
                        <>
                            <a href="#about">About</a>
                            <a href="#projects">Projects</a>
                            <a href="#gallery">My vibe</a>
                            <a href="#contact">Contact</a>
                        </>
                    ) : (
                        <>
                            <Link to="/#about">About</Link>
                            <Link to="/#projects">Projects</Link>
                            <Link to="/#gallery">My vibe</Link>
                            <Link to="/#contact">Contact</Link>
                        </>
                    )}
                    <Link to="/blog" className={location.pathname === "/blog" ? "active" : ""}>Blog</Link>
                </nav>
            </div>
            <div className="location">
                <span className="nav-label">Based in Tbilisi, GE &amp; Baku, AZ</span>
                <span className="nav-secondary">Generalist</span>
            </div>
        </header>
    );
};

export default NavBar;
